import constants from "../../../../server/lib/constants";

function hoverPlace(place) {
  return {
    type: "HOVER_PLACE",
    data: place,
  };
}

function fetchNearbyDone(id, pois) {
  return {
    type: "FETCH_NEARBY_DONE",
    data: {
      id,
      nearby: pois,
    },
  };
}

function fetchNearby(id) {
  return (dispatch) => {
    $.ajax({
      url: `/${constants.AJAX_PATH}/pois/${id}/nearby`,
      contentType: "application/json",
    }).done((pois) => {
      if (pois) {
        dispatch(fetchNearbyDone(id, pois));
      }
    });

    dispatch({
      type: "FETCH_NEARBY",
    });
  };
}

export {
  hoverPlace,
  fetchNearby,
};



// WEBPACK FOOTER //
// ./assets/pois/actions/nearbyPlaces.js